/**
 * Converts an analytics properties object to a JSON string for use in
 * HTML data attributes. Returns null if the object is empty or null.
 *
 * @param {Object|null|undefined} properties - Analytics properties object
 * @returns {string|null} JSON string or null if empty
 */
export function stringifyAnalyticsProperties(properties) {
  if (!properties || Object.keys(properties).length === 0) {
    return null;
  }
  return JSON.stringify(properties);
}

/**
 * Parses analytics properties from a JSON string stored in a DOM data attribute.
 * Returns null if the string is empty or invalid JSON.
 *
 * @param {string|null|undefined} jsonString - JSON string from data attribute
 * @returns {Object|null} Parsed properties object or null if invalid/empty
 */
export function parseAnalyticsProperties(jsonString) {
  if (!jsonString) {
    return null;
  }

  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.warn('Invalid JSON in data-analytics-properties:', jsonString);
    return null;
  }
}
